import React, { ReactElement } from "react";
import { Table } from "antd";
import { rowClassName } from "../../DateRangeComparison";
import { ProcessedAdsByClusterRecord } from "../../../redux/types/reportTypes";
import "./index.scss";

export const columns = [
  {
    title: "Cluster",
    dataIndex: "cluster",
  },
  {
    title: "Period 1",
    dataIndex: "period1",
  },
  {
    title: "Period 2",
    dataIndex: "period2",
  },
  {
    title: "Difference",
    dataIndex: "difference",
  },
  {
    title: "Percentual Difference",
    dataIndex: "percentualDifference",
  },
];

type ClusterTableProps = {
  loading: boolean;
  records: Array<ProcessedAdsByClusterRecord>;
};

const ClusterTable = ({ loading, records }: ClusterTableProps): ReactElement => (
  <Table
    className="cluster-table"
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="cluster"
    pagination={false}
    scroll={{ y: 250 }}
    rowClassName={rowClassName}
  />
);

export default ClusterTable;
